/*
  德语
*/
export default {
  orderList: {
    AllOrder: 'Alles in Ordnung',
    WaitingPayment: 'Zahlung warten',
    Pending: 'warten auf den Versand',
    ToBeSighed: 'im Transit',
    Refunding: 'Rückerstattung',
    YouHave: 'Sie haben',
    orders: 'Bestellungen',
    OrderID: 'ID der Bestellung',
    Customer: 'Kunde',
    coupon: 'Coupon',
    TotalAmount: 'Betrag insgesamt',
    PayNow: 'Jetzt bezahlen',
    ViewDetails: 'Details anzeigen',
    CancelOrder: 'Bestellung abbrechen',
    Delete: 'Löschen',
    selectContent: 'Inhalt auswählen',
    startDate: 'Datum des Beginns',
    endDate: 'Datum des Endes',
    inputPlaceholder: 'Suche nach Bestellnummer, SKU ODER Produktname',
    RequestRefund: 'Antrag auf Erstattung',
    ConfirmReceipt: 'Bestätigen Sie den Eingang',
    CancelReason: 'Abbruch der Begründung',
    Verification: 'Überprüfung',
    RefundReason: 'Grund der Erstattung',
    Remake: 'Bemerkung',
    cancel: 'Stornieren',
    submit: 'bestimmen',
    ConfirmReceiptTitle: 'Sind Sie sicher, dass Sie die Ware erhalten haben und die Qualität den Vertrag zwischen den Parteien der Transaktion erfüllt?',
    ConfirmReceiptContent: 'Wenn die Bestätigung korrekt ist, klicken Sie bitte unten auf "Bestätigen", um die Empfangsbestätigung auszufüllen.',
    removeTheStore: 'entfernen Sie den Speicher',
    CancellationReasonIsRequired: 'Die Stornierung ist erforderlich',
    RefundReasonIsRequired: 'Die Rückerstattung ist erforderlich',
    Paypal: 'Paypal',
    CreditCard: 'KreditkartenName',
    Balance: 'Saldo',
    SelectByStatus: 'Nach Status auswählen',
    SelectByPlatform: 'Wählen Sie nach Plattform',
    FulfillOrder: 'Vollständige Bestellung',
    Store: 'Speichern',
    StoreOrderID: 'Dokument speichern',
    TrackingNumber: 'Nummer der Verfolgung',
    ShippingCarrier: 'Spediteur und Spediteur',
    TrackingURL: 'URL der Verfolgung',
    cancelBtn: 'Stornieren',
    ok: 'Okay',
    emptyTips1: 'Ihre Bestellliste ist leer!',
    emptyTips2: 'Hier können Sie Ihre Bestellungen verwalten und bearbeiten',
    ChooseProduct: 'Produkt auswählen',
    ChooseProductTips: 'So finden Sie die Liste Prodcuts',
    ConnectANewStore: 'Einen neuen Store verbinden',
    ConnectANewStoreTips: 'So verbinden Sie einen neuen Shop',
    selectAll: 'Alle auswählen',
    orderStatusSubTip: 'Rückerstattung fehlgeschlagen, bitte verbinden Sie unser Support-Team'
  },
  orderDetail: {
    PayNow: 'Jetzt bezahlen',
    ConfirmReceipt: 'Bestätigen Sie den Eingang',
    StoreOrderID: 'Dokument speichern',
    OrderID: 'ID der Bestellung',
    Source: 'Quelle',
    IncomeStatement: 'Gewinn- und Verlustrechnung',
    CommodityInformation: 'Informationen über Waren',
    ShipFrom: 'Schiff von',
    ItemNo: 'Artikel Nr.',
    TheDetail: 'Das Detail',
    Notes: 'Anmerkungen',
    OrderStatus: 'Status der Bestellung',
    BalancePayment: 'Zahlung des Restbetrags',
    PaymentTime: 'Zeit der Zahlung',
    PaymentId: 'Zahlungs-ID',
    ItemSubtotal: 'Teilsumme',
    ShippingSubtotal: 'Lieferung',
    tax: 'Steuer',
    PaymentAmount: 'Betrag der Zahlung',
    ShippingAddress: 'Adresse des Versands',
    ConfirmReceiptModalTitle: 'Sind Sie sicher, dass Sie die Ware erhalten haben und die Qualität den Vertrag zwischen den Parteien der Transaktion erfüllt?',
    ConfirmReceiptModalContent: 'Wenn die Bestätigung korrekt ist, klicken Sie bitte unten auf "Bestätigen", um die Empfangsbestätigung auszufüllen.',
    Cancel: 'Abbrechen',
    Submit: 'Einreichen',
    removeTheStore: 'entfernen Sie den Speicher',
    WaitingPayment: 'Zahlung warten',
    WaitingPaymentTips: 'Ihre Bestellung ist noch nicht bezahlt. Klicken Sie auf "Jetzt bezahlen", um fortzufahren. ',
    OrderCreation: 'Erstellung von Ordnern',
    Finish: 'Fertig',
    PaymentSuccessful: 'Zahlung erfolgreich',
    IncorrectAddressInformation: 'Falsche Adressinformationen',
    CancelTips: 'Ihre Bestellung wurde erfolgreich storniert',
    Pending: 'warten auf den Versand',
    PendingSecondStatus: 'Typischerweise dauert weniger als 24-Stunden. Wir lassen Sie wissen, sobald die Bestellung versandt hat',
    PendingTips: 'Jedes einzelne Produkt durchläuft unsere strenge Qualitätskontrolle, bevor wir es an Ihre Kunden senden',
    Shipped: 'Versand',
    Complete: 'Komplett',
    ShippedTips1: 'Ihre Bestellung ist auf dem Weg!',
    PartialDelivery: 'Teilweise versandt',
    ShippedTips2: 'Einige Ihrer Produkte wurden noch nicht versandt',
    Refunding: 'Rückerstattung',
    PartialRefund: 'Teilerstattung',
    refundedTipsNew: 'Der Gesamtrückerstattungsbetrag für Ihre Bestellung beträgt',
    RefundingSecondStatus: 'Ihre Rückerstattung wird innerhalb von 1-3 Geschäftstagen verarbeitet',
    RefundingTips: 'Der Erstattungsantrag wurde gestellt. Warten auf die Bearbeitung',
    Refund: 'Erstattung',
    Refunded: 'Zurückweisung',
    RefundedSecondStatus: 'Abhängig von Ihrem Finanzinstitut kann es bis zu 14 Tage dauern, bis die Mittel in Ihrem Konto zu zeigen',
    RefundedTips: 'Der Erstattungsantrag wurde angenommen. Der bereits gezahlte Betrag wird an die ursprüngliche Zahlungsmethode zurückerstattet.',
    CompleteSecondStatus: 'Transaktion abgeschlossen',
    CompleteTips: 'Die Bestellung ist abgeschlossen, vielen Dank für Ihre Unterstützung',
    ShippingMethod: 'Versandart ',
    MyOrder: 'Meine Bestellung',
    OrderInformation: 'Informationen zur Bestellung',
    Product: 'Produkt',
    PurchasePrices: 'Einkaufspreise (Preise)',
    prices: 'Preise',
    Quantity: 'Menge',
    Subtotal: 'Zwischensumme',
    Profit: 'Gewinn',
    ConfirmReceiptTips: 'Achten Sie auf die Quittung',
    trackingCode: 'TrackingCode',
    DeliveryTime: 'Zeit der Lieferung',
    logisticsProviders: 'LogistikProvider',
    payment: 'Zahlung',
    NotToDeliverGoods: 'Nicht zur Lieferung',
    LogisticsInformation: 'Logistische Informationen',
    PartialDeliveryTips: 'Einige Produkte wurden noch nicht versandt，Wir werden Sie informieren, sobald sie versandt wurden',
    PaymentInformation: 'Informationen zur Zahlung',
    Balance: 'balance',
    CreditCard: 'Kreditkarte',
    payFail: 'Zahlung fehlgeschlagen',
    Remaining: 'Verbleibend',
    WaitingPaymentWarning: 'Bestellungen, die nicht für mehr als 120 Stunden bezahlt wurden, werden storniert',
    OrderCancelled: 'Bestellung storniert',
    OrderConfirmed: 'Bestellung bestätigt',
    Shipping: 'Versand',
    OrderComplete: 'Geliefert',
    OrderSubmitted: 'Abgesandte Bestellung',
    PleaseInput: 'Bitte eingeben',
    Note: 'Notiz',
    EditNote: 'Notiz bearbeiten',
    Edit: 'Bearbeiten',
    EditNoteSuccessTip: 'Notizinhalt erfolgreich aktualisiert.',
    NoteTip: 'Hier ist der Inhalt der Notiz.'
  }
}
